import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { MapPin, Plus, Trash2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import { toast } from "sonner";

export const SlotsDetails = ({clientDetails, fetchSlots, slots, handleAddSlot}) => {
  const handleDeleteSlot = async (slotId) => {
    try {
      await axios.delete(`${API}/admin/slots/${slotId}`);
      toast.success("Parking slot deleted successfully!");
      fetchSlots();
    } catch (error) {
      toast.error("Failed to delete parking slot");
    }
  };
  return (
    <>
      <div className="flex justify-end mb-4">
        <Button
          data-testid="add-vehicle-btn"
          className="bg-[#1A3C34] hover:bg-[#142E28] text-white rounded-full px-6"
          onClick={() => {
            const fileInput = document.createElement("input");
            fileInput.type = "file";
            fileInput.accept = ".csv";
            fileInput.onchange = (e) => {
              const file = e.target.files[0];
              if (file) {
                handleAddSlot(e, file);
              }
            };
            fileInput.click();
          }}
        >
          <Plus className="mr-2" size={20} />
          Upload Slots Data
        </Button>
      </div>
      <div className="fade-in">
        {slots.length === 0 ? (
          <Card className="p-12 text-center">
            <MapPin className="mx-auto mb-4 text-gray-400" size={48} />
            <p className="text-gray-600 text-lg mb-4">
              No parking slots configured
            </p>
          </Card>
        ) : (
          <Card className="p-6 border border-gray-100">
            <h2 className="text-2xl font-bold text-[#1A3C34] mb-6">
              All Parking Slots
            </h2>
            <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4">
              {slots.map((slot) => (
                <div
                  key={slot._id}
                  data-testid={`slot-${slot._id}`}
                  className={`p-6 rounded-xl border-2 transition-all relative ${
                    slot.is_booked
                      ? "border-red-300 bg-red-50"
                      : "border-green-300 bg-green-50"
                  }`}
                >
                  <Button
                    data-testid={`delete-slot-${slot._id}`}
                    onClick={() => handleDeleteSlot(slot._id)}
                    variant="ghost"
                    className="absolute top-2 right-2 text-red-600 hover:bg-red-100 rounded-full p-2 h-8 w-8"
                  >
                    <Trash2 size={16} />
                  </Button>

                  <div className="w-12 h-12 bg-[#1A3C34] rounded-xl flex items-center justify-center mb-4">
                    <MapPin className="text-white" size={24} />
                  </div>

                  <h3 className="text-2xl font-bold text-[#1A3C34] mb-2">
                    {slot.slot_number}
                  </h3>

                  <div className="space-y-1 mb-3">
                    <p className="text-sm text-gray-600">
                      <span className="font-medium">Floor:</span> {slot.floor}
                    </p>
                    <p className="text-sm text-gray-600">
                      <span className="font-medium">Location:</span>{" "}
                      {slot.location}
                    </p>
                  </div>

                  <div
                    className={`px-3 py-1 rounded-full text-xs font-medium inline-block ${
                      slot.is_booked
                        ? "bg-red-200 text-red-800"
                        : "bg-green-200 text-green-800"
                    }`}
                  >
                    {slot.is_booked ? "Booked" : "Available"}
                  </div>
                </div>
              ))}
            </div>
          </Card>
        )}
      </div>
    </>
  );
};
